/**
 * Shapes the `/livestream/mosttipped` response for the live page's
 * Top supporters panel. Each entry is one tipper on this stream, with
 * `highestTipped` already converted to USD by skcore.
 */

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
  maximumFractionDigits: 1,
});

const usdSmall = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatSupportAmount = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) return "$0";
  return value < 1000 ? usdSmall.format(value) : usd.format(value);
};

export const toSupporterRows = (entries) => {
  if (!Array.isArray(entries)) return [];
  return entries
    .filter((entry) => entry && entry._id)
    .map((entry) => ({
      id: String(entry._id),
      name: (entry.fullName || "").trim() || "Anonymous",
      avatar: entry.profilePic?.filePath || null,
      amount: Number(entry.highestTipped) || 0,
    }))
    .sort((a, b) => b.amount - a.amount)
    .map((row, index) => ({ ...row, rank: index + 1 }));
};

export const findViewerRow = (rows, userId) =>
  userId ? rows.find((row) => row.id === String(userId)) || null : null;
